import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  function changeTab(tabmenu, labels, inputs) {
    if (window.location.pathname === '/dashboard' || window.location.pathname === '/') {
      const { hash } = window.location
      if (hash) {
        const label = Array.from(labels).filter(elem => `#${elem.attributes.tabtarget.value}` === decodeURI(hash.replace('_', ' ')))
        if (label.length) {
          Array.from(tabmenu.children('input')).forEach((elem) => {
            elem.removeAttribute('checked')
          })
          const inp = Array.from(inputs).find(input => input.id === label[0].attributes.for.value)
          inp.setAttribute('checked', true)
        } else {
          inputs[0].setAttribute('checked', true)
          window.history.pushState({}, '', `#${labels[0].attributes.tabtarget.value}`.replace(/ /g, '_'))
        }
      } else {
        inputs[0].setAttribute('checked', true)
        window.history.pushState({}, '', `#${labels[0].attributes.tabtarget.value}`.replace(/ /g, '_'))
      }
    }
  }

  const tabmenu = $('#tab-menu')
  const labels = tabmenu.children('label')
  const inputs = tabmenu.children('input')

  changeTab(tabmenu, labels, inputs)
  labels.click((elem) => {
    window.history.pushState({}, '', `#${elem.currentTarget.attributes.tabtarget.value}`.replace(/ /g, '_'))
    changeTab(tabmenu, labels, inputs)
  })
  window.addEventListener('hashchange', () => changeTab(tabmenu, labels, inputs))
})
